import React from 'react'
import { TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native'
import { Text } from '../text'
import { Medal } from '../medal'
import LinearGradient from 'react-native-linear-gradient'

interface MedalGroupCardProps {
  level: string
  title: string
  style?: ViewStyle
  count?: number
  onPress?: () => void
}
export const MedalGroupCard = (props: MedalGroupCardProps) => {
  const { level, style, onPress, title, count } = props
  const renderLabelColor = () => {
    switch (level) {
      case 'Gold':
        return { background: '#ffffff', text: '#EDB552', gradient: 'rgba(237, 181, 82, 0.15)' }
      case 'Silver':
        return { background: '#ffffff', text: '#778390', gradient: 'rgba(113, 116, 132, 0.15)' }
      case 'Bronze':
        return { background: '#ffffff', text: '#A59E8E', gradient: 'rgba(170, 144, 131, 0.15)' }
      default:
        return { background: '#ffffff', text: '#D2D2D4', gradient: 'rgba(210, 210, 212, 0.15)' }
    }
  }
  return (
    <TouchableOpacity
      // @ts-ignore
      dataSet={{ qat: `${level}_medal` }}
      style={{ ...ROOT, ...style }}
      onPress={onPress}
    >
      <View style={CONTAINER}>
        <Medal hideRecall style={{ alignSelf: 'center' }} level={level} size={32} />
        <View style={TITLE}>
          <Text
            style={{ textAlign: 'center' }}
            tx={`Certifications.${title.toLocaleLowerCase()}`}
            variant="body1Emphasized"
          />
        </View>
        <View style={LABEL}>
          <LinearGradient
            useAngle
            angle={180}
            locations={[0, 1]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            colors={[renderLabelColor().gradient, renderLabelColor().gradient]}
            style={COUNT_STYLE}
          >
            <Text style={{ ...COUNT_TEXT, color: renderLabelColor().text }} text={`${count}`} />
          </LinearGradient>
        </View>
      </View>
    </TouchableOpacity>
  )
}

const ROOT: ViewStyle = {
  height: 143,
  width: 135,
  borderWidth: 2,
  borderColor: '#F3F2F1',
  borderRadius: 20,
  backgroundColor: '#fff',
  padding: 16,
  elevation: 2,
}
const CONTAINER: ViewStyle = { flexDirection: 'column', display: 'flex', flex: 1 }
const TITLE: ViewStyle = {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  flexDirection: 'column',
  top: 4,
}
const LABEL: ViewStyle = {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
}

const COUNT_STYLE: ViewStyle = {
  height: 25,
  minWidth: 40,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  borderRadius: 10,
}

const COUNT_TEXT: TextStyle = {
  fontWeight: '700',
  fontSize: 12,
  color: '#EAB021',
}
